//TYPES
export const PLAN_FINANCIAL_PDF = 'PLAN_FINANCIAL_PDF';
export const OPEN_PDF_VIEWER = 'OPEN_PDF_VIEWER';
export const PLAN_FINANCIAL_PDF_SUCCESS = 'PLAN_FINANCIAL_PDF_SUCCESS';
export const CHANGE_PDF_INFO = 'CHANGE_PDF_INFO';
export const INIT_PDF_STATE = 'INIT_PDF_STATE';
export const CHANGE_PDF_VIEWER_STATE = 'CHANGE_PDF_VIEWER_STATE';
export const SEARCH_FINANCIAL_CUSTOMER = 'SEARCH_FINANCIAL_CUSTOMER';
export const SEARCH_FINANCIAL_CUSTOMER_SUCCESS =
  'SEARCH_FINANCIAL_CUSTOMER_SUCCESS';
export const SEND_FINANCIAL_PDF = 'SEND_FINANCIAL_PDF';
export const SEND_FINANCIAL_PDF_SUCCESS = 'SEND_FINANCIAL_PDF_SUCCESS';
export const SEARCH_FINANCIAL_BOOKMARK = 'SEARCH_FINANCIAL_BOOKMARK';
export const SEARCH_FINANCIAL_BOOKMARK_SUCCESS =
  'SEARCH_FINANCIAL_BOOKMARK_SUCCESS';
export const SEARCH_PLAN_COMPLETE = 'SEARCH_PLAN_COMPLETE';
export const SEND_SIMULATION_PDF = 'SEND_SIMULATION_PDF';

//ACTIONS
export const planFinancialPDF = payload => {
  return { type: PLAN_FINANCIAL_PDF, payload };
};
export const openPDFViewer = data => {
  return { type: OPEN_PDF_VIEWER, payload: data };
};
export const changePdfInfo = payload => {
  return { type: CHANGE_PDF_INFO, payload: payload };
};
export const initPdfState = () => {
  return { type: INIT_PDF_STATE };
};
export const changePdfViewerState = payload => {
  return { type: CHANGE_PDF_VIEWER_STATE, payload };
};
export const searchFinancialCustomer = () => {
  return { type: SEARCH_FINANCIAL_CUSTOMER };
};
export const sendFinancialPdf = payload => {
  return { type: SEND_FINANCIAL_PDF, payload };
};
export const searchFinancialBookmark = payload => {
  return { type: SEARCH_FINANCIAL_BOOKMARK, payload };
};
export const searchPlanComplete = payload => {
  return { type: SEARCH_PLAN_COMPLETE, payload };
};
export const sendSimulationPdf = payload => {
  return { type: SEND_SIMULATION_PDF, payload };
};
